const blogInfo={
  "blog/mastering-guitar-scale-shapes-practical-approach": "/blogdata/mastering-guitar-scale-shapes-practical-approach",
  "blog/ear-training-for-guitarists-why-bother": "/blogdata/ear-training-for-guitarists-why-bother",
};
export default blogInfo;
